export enum RedemptionMethod {
  ACH = 'ACH',
  PayPal = 'Paypal',
  PerfectGift = 'Perfectgift',
  PerfectGiftVirtual = 'Perfectgiftvirtual',
  ColumnLithic = 'ColumnLithic',
  ColumnLithicVirtual = 'ColumnLithicVirtual',
}

export default RedemptionMethod
